// Croatian translations
const hr = {
  common: {
    appName: "Protego",
    subtitle: "Alat za globalnu provjeru usklađenosti",
    footer: "Sva prava pridržana",
    search: "Pretraži",
    profile: "Profil",
    admin: "Admin",
    loading: "Učitavanje...",
    welcome: "Pozdrav",
    error: "Greška",
    success: "Uspjeh",
    save: "Spremi",
    cancel: "Odustani",
    edit: "Uredi",
    delete: "Izbriši",
    close: "Zatvori",
    back: "Natrag",
    next: "Dalje",
    submit: "Pošalji",
    download: "Preuzmi",
    monitor: "Praćenje",
    confirm: "Potvrdi",
    processing: "Obrada...",
    completed: "Završeno",
    generating: "Generiranje...",
    retry: "Pokušaj ponovno",
    unknown: "Nepoznato",
    copyLink: "Kopiraj poveznicu",
    copied: "Kopirano!",
    backToSearch: "Natrag na pretragu",
    backToCases: "Natrag na slučajeve",
    backToReport: "Natrag na izvješće",
    backToHistory: "Natrag na povijest",
    backToMonitoring: "Natrag na praćenje",
    yes: "Da",
    no: "Ne",
    organization: "Organizacija",
    active: "Aktivno",
    saving: "Spremanje..."
  },
  welcomeSection: {
    advancedSearch: {
      title: "Napredno Pretraživanje",
      description: "Inteligentni algoritmi za podudaranje imena prepoznaju varijacije u pisanju i strukturi."
    },
    confidenceScoring: {
      title: "Ocjenjivanje Pouzdanosti",
      description: "Rezultati su rangirani s detaljnim razinama pouzdanosti za identifikaciju relevantnih podudaranja."
    },
    complianceReady: {
      title: "Spremno za Usklađenost",
      description: "Stvaranje izvještaja o provjeri s jedinstvenim ID-ovima za regulatornu usklađenost."
    }
  },
  search: {
    placeholder: "Unesite ime za provjeru protiv lista sankcija...",
    button: "Pretraži",
    advancedOptions: "Napredne Opcije",
    noResults: "Nema pronađenih rezultata",
    resultsCount: "Pronađeno {{count}} rezultata",
    entityType: "Vrsta Entiteta",
    personType: "Osobe",
    enterpriseType: "Poduzeća",
    confidence: {
      veryHigh: "Vrlo Visoka",
      high: "Visoka",
      medium: "Srednja",
      low: "Niska"
    },
    searching: "Pretraživanje lista sankcija...",
    loading: "Učitavanje...",
    scanningRecords: "Skeniranje zapisa baze podataka",
    processed: "Obrađeno",
    of: "od",
    records: "zapisa",
    searchResults: "Rezultati Pretraživanja",
    foundMatches: "Pronađeno {{count}} podudaranja za \"{{term}}\"",
    showingTop: "Prikaz prvih {{shown}} podudaranja od ukupno {{total}} (poredano po relevantnosti)",
    all: "Sve",
    riskMatch: "Rizično Podudaranje",
    veryHighRiskMatch: "Vrlo Visok Rizik Podudaranja",
    highRiskMatch: "Visok Rizik Podudaranja",
    mediumRiskMatch: "Srednji Rizik Podudaranja",
    lowRiskMatch: "Nizak Rizik Podudaranja",
    filters: {
      all: "Sve",
      veryHigh: "Vrlo Visoko",
      high: "Visoko",
      medium: "Srednje",
      low: "Nisko"
    },
    includeDismissed: "Uključi odbačene",
    searchId: "ID pretrage",
    caseStatus: "Status slučaja",
    caseStatusPending: "Čeka pregled",
    caseStatusPartial: "Djelomično pregledano",
    caseStatusCompleted: "Pregled završen",
    name: "Ime",
    companyName: "Naziv tvrtke"
  },
  results: {
    noSanctionsFound: "Sankcije nisu pronađene",
    cleared: "se ne pojavljuje ni na jednoj listi sankcija. Ova osoba je provjerena prema svim nadziranim bazama podataka o sankcijama.",
    clearedEntity: "se ne pojavljuje ni na jednoj listi sankcija. Ovaj subjekt je provjeren prema svim nadziranim bazama podataka o sankcijama.",
    individualCleared: "Ova osoba je provjerena prema svim nadziranim bazama podataka o sankcijama.",
    companyCleared: "Ova tvrtka je provjerena prema svim nadziranim bazama podataka o sankcijama.",
    verificationId: "ID verifikacije",
    recordsScanned: "Pregledano zapisa",
    searchTimestamp: "Vrijeme pretraživanja",
    downloadPdfReport: "Preuzmi PDF izvještaj",
    addToMonitoring: "Dodaj u praćenje",
    removeFromMonitoring: "Ukloni iz praćenja",
    sourcesChecked: "Provjereni izvori",
    financialSanctions: "Financijske sankcije",
    travelBans: "Zabrane putovanja",
    unSanctions: "UN sankcije",
    databaseChecked: "Baza podataka provjerena",
    disclaimer: "Ovaj rezultat provjere je trenutni pregled i ne jamči budući status usklađenosti.",
    legalNote: "Za potrebe pravne usklađenosti, molimo zadržite kopiju ovog izvještaja.",
    generatingPdf: "Generiranje PDF izvještaja...",
    scoreBreakdown: "Raščlamba Ocjene",
    tokenMatch: "Podudaranje Tokena",
    positional: "Pozicija",
    transliteration: "Transliteracija",
    distributedMatchBoost: "Pojačanje Distribuiranog Podudaranja",
    culturalPattern: "Kulturološki Obrazac",
    distributedNameMatch: "Distribuirano Podudaranje Imena",
    crossMatchExplanation: "Vaš pojam za pretraživanje \"{{term}}\" podudara se s ovim zapisom jer se različiti dijelovi pojavljuju u više varijanti imena:",
    matchedVariants: "Podudarajuće Varijante",
    sanctionsDetails: "Detalji Sankcija",
    category: "Kategorija",
    program: "Program",
    listingDate: "Datum Uvrštenja",
    lastUpdated: "Zadnje Ažurirano",
    documents: "Dokumenti",
    sanctionsReport: "Izvještaj o Sankcijama",
    clearanceReport: "Izvještaj o Provjeri",
    issuedBy: "Izdao",
    issuedByValue: "Protego",
    expiry: "Vrijedi Do",
    reportTimestamp: "Izvještaj Generiran",
    searchDate: "Datum pretraživanja",
    validUntil: "Vrijedi do",
    generatingPdfReport: "Generiranje PDF izvještaja",
    citizenship: "Državljanstvo",
    alternativeNames: "Alternativna Imena",
    documentId: "ID Dokumenta",
    viewOnEUSanctionsTracker: "Pogledaj na EU Pregledniku Sankcija",
    viewOnUNSecurityCouncilSanctionsList: "Pogledaj na UN Listi Sankcija Vijeća Sigurnosti",
    function: "Funkcija",
    fuzzy: "neizravno",
    dismiss: "Odbaci",
    confirmMatch: "Potvrdi podudaranje",
    confirmed: "Potvrđeno",
    dismissed: "Odbačeno",
    confirmDismiss: "Odbaciti kao lažni pozitiv?",
    dismissExplanation: "Ovo će označiti rezultat kao odbačen i zabilježiti ga kao lažni pozitiv u vašem sustavu upravljanja.",
    undoReview: "Poništi odluku",
    sanctionType: "Vrsta sankcije",
    issueDate: "Datum izdavanja",
    country: "Država",
    moreDetails: "Više detalja",
    runBy: "Pokrenuo"
  },
  report: {
    title: "Izvještaj o provjeri",
    subjectInformation: "Informacije o subjektu",
    name: "Ime",
    generated: "Izvještaj generiran",
    screeningDetails: "Detalji provjere",
    authoritiesChecked: "Provjerena tijela",
    verification: "Verifikacija",
    issuedBy: "Izdao",
    issuedByValue: "Protego",
    verifyAt: "Provjerite na",
    verificationDisclaimer: "Ovaj izvještaj je trenutačna verifikacija i ne jamči budući status usklađenosti.",
    generatedOn: "Generirano",
    verificationId: "ID provjere",
    runBy: "Pokrenuo"
  },
  authorities: {
    euCommission: "European Commission",
    euCommissionDescription: "Financijske sankcije, Zabrane putovanja",
    unitedNations: "United Nations",
    unitedNationsDescription: "Sankcije Vijeća sigurnosti"
  },
  auth: {
    login: "Prijava",
    signup: "Registracija",
    logout: "Odjava",
    welcomeBack: "Dobrodošli natrag",
    email: "E-mail",
    password: "Lozinka",
    confirmPassword: "Potvrdi Lozinku",
    forgotPassword: "Zaboravili ste lozinku?",
    resetPassword: "Promijeni Lozinku",
    resetPasswordPrompt: "Unesite svoj e-mail za primanje poveznice za resetiranje lozinke",
    sendResetLink: "Pošalji link za promjenu lozinke",
    backToLogin: "Natrag na Prijavu",
    alreadyHaveAccount: "Već imate račun?",
    dontHaveAccount: "Nemate račun?",
    noAccount: "Nemate račun?",
    createAccount: "Kreirajte Račun",
    loginNow: "Prijavite se za nastavak korištenja Pretraživača Sankcija",
    enterEmail: "Unesite vaš e-mail",
    enterPassword: "Unesite vašu lozinku",
    enterName: "Unesite vaše ime",
    confirmYourPassword: "Potvrdite vašu lozinku",
    passwordsDontMatch: "Lozinke se ne podudaraju",
    accountCreated: "Račun uspješno kreiran!",
    accountCreatedSuccessfully: "Račun uspješno kreiran! Sada ste prijavljeni.",
    passwordResetEmailSent: "E-mail za resetiranje lozinke poslan! Provjerite svoju e-mail adresu.",
    resetLinkSent: "Poveznica za resetiranje poslana na vaš e-mail.",
    checkEmail: "Molimo provjerite svoju e-mail adresu.",
    loginError: "Neuspjela prijava. Molimo provjerite vaše podatke.",
    signupError: "Neuspjelo kreiranje računa. E-mail je možda već u upotrebi.",
    resetError: "Neuspjelo slanje e-maila za resetiranje. Provjerite e-mail adresu.",
    switchToLightMode: "Prebaci na Svijetli Način",
    switchToDarkMode: "Prebaci na Tamni Način",
    name: "Ime",
    resetPasswordInstructions: "Unesite svoju e-mail adresu i poslat ćemo vam poveznicu za resetiranje lozinke.",
    sessionExpired: "Vaša sesija je istekla. Molimo prijavite se ponovno.",
    or: "ili",
    continueWithGoogle: "Nastavite s Google računom",
    continueWithMicrosoft: "Prijavite se putem Microsoft računa",
    emailVerificationRequired: "Molimo potvrdite svoju e-mail adresu prije nastavka. Provjerite svoju e-mail poštu za verifikacijski link.",
    verificationEmailSent: "Verifikacijski e-mail je poslan na vašu e-mail adresu. Provjerite svoju poštu i potvrdite e-mail prije nastavka.",
    verificationEmailResent: "Verifikacijski e-mail je ponovno poslan. Provjerite svoju poštu.",
    verificationRequired: "Molimo potvrdite svoju e-mail adresu za nastavak.",
    resendVerification: "Ponovno pošalji verifikacijski e-mail",
    emailVerified: "E-mail uspješno verificiran!",
    verifyYourEmail: "Potvrdite Vašu E-mail Adresu",
    verificationInstructions: "Poslali smo vam verifikacijski e-mail na vašu adresu. Provjerite svoju poštu i kliknite na verifikacijski link za aktivaciju vašeg računa.",
    iAlreadyVerified: "Već sam verificirao svoju e-mail adresu",
    emailNotVerified: "Vaša e-mail adresa još nije potvrđena. Provjerite svoju poštu.",
    resendVerificationError: "Neuspjelo ponovno slanje verifikacijskog e-maila. Pokušajte ponovo kasnije.",
    resendIn: "Ponovno pošalji za",
    resendCooldown: "Molimo pričekajte prije nego zatražite novi e-mail.",
    loginRequired: "Molimo prijavite se za pristup ovoj stranici.",
    verificationPageTitle: "Potrebna je verifikacija e-maila"
  },
  orgAdmin: {
    title: "Administracija Organizacije",
    subtitle: "Upravljajte vašom organizacijom: {{orgName}}",
    accessDenied: "Pristup Odbijen",
    accessDeniedMessage: "Nemate dozvolu za pristup stranici administracije organizacije. Samo administratori organizacije mogu vidjeti ovaj sadržaj.",
    tabs: {
      userManagement: "Upravljanje Korisnicima",
      organizationSettings: "Postavke Organizacije",
      billingSubscription: "Naplaćivanje i Pretplata"
    },
    userManagement: {
      title: "Članovi Organizacije",
      subtitle: "Upravljajte korisnicima u vašoj organizaciji",
      inviteUser: "Pozovi Korisnika",
      inviteNewUser: "Pozovi Novog Korisnika",
      emailAddress: "E-mail Adresa",
      emailPlaceholder: "korisnik@primjer.hr",
      role: "Uloga",
      roles: {
        member: "Član",
        admin: "Administrator"
      },
      sendInvitation: "Pošalji Pozivnicu",
      pendingInvitations: "Pozivnice na Čekanju",
      inviteCode: "Kod Pozivnice",
      cancelInvitation: "Otkaži pozivnicu",
      activeMembers: "Aktivni Članovi",
      user: "Korisnik",
      joined: "Pridružio se",
      actions: "Akcije",
      unknown: "Nepoznato",
      confirmRemoveUser: "Jeste li sigurni da želite ukloniti ovog korisnika iz organizacije?",
      userAlreadyExists: "Korisnik je već dio ove organizacije",
      emailRequired: "E-mail je obavezan",
      inviteUserFailed: "Pozivanje korisnika nije uspjelo. Molimo pokušajte ponovno.",
      updateRoleFailed: "Ažuriranje uloge korisnika nije uspjelo",
      cancelInviteFailed: "Otkazivanje pozivnice nije uspjelo",
      removeUserFailed: "Uklanjanje korisnika nije uspjelo",
      loadUsersFailed: "Učitavanje korisnika nije uspjelo",
      teamMemberLimit: {
        exceeded: "Limit članova tima prekoračen",
        warning: "Imate {{current}}/{{limit}} članova tima",
        cannotJoin: "Ova organizacija je dosegla svoj maksimalni limit članova tima",
        cannotInvite: "Ne možete pozvati više članova tima. Nadogradite svoj plan da biste dodali više.",
        currentCount: "{{current}}/{{limit}} Članovi tima",
        upgradeRequired: "Nadogradite svoj plan da biste dodali više članova tima",
        atLimit: "Dosegli ste svoj limit članova tima",
        nearLimit: "Približavate se svom limitu članova tima"
      }
    },
    organizationSettings: {
      title: "Postavke Organizacije",
      subtitle: "Konfigurirajte globalne postavke vaše organizacije",
      organizationDetails: "Podaci o Organizaciji",
      organizationName: "Naziv Organizacije",
      domain: "Domena",
      domainCannotChange: "Domena se ne može promijeniti nakon stvaranja organizacije",
      defaultSearchSettings: "Zadane Postavke Pretraživanja",
      defaultSearchCadence: "Zadana Učestalost Pretraživanja",
      defaultCadenceHelp: "Zadana učestalost za nove korisnike",
      timezone: "Vremenska Zona",
      cadenceOptions: {
        "1year": "1 Godina",
        "6months": "6 Mjeseci",
        "3months": "3 Mjeseca",
        "1month": "1 Mjesec"
      },
      timezoneOptions: {
        "UTC": "UTC",
        "America/New_York": "Istočno Vrijeme",
        "America/Chicago": "Središnje Vrijeme",
        "America/Denver": "Planinska Zona",
        "America/Los_Angeles": "Tihomirska Zona",
        "Europe/London": "London",
        "Europe/Paris": "Pariz",
        "Europe/Berlin": "Berlin",
        "Asia/Tokyo": "Tokio",
        "Asia/Shanghai": "Šangaj"
      },
      saveChanges: "Spremi Promjene",
      settingsUpdated: "Postavke uspješno ažurirane",
      settingsUpdateFailed: "Ažuriranje postavki nije uspjelo. Molimo pokušajte ponovno."
    },
    billing: {
      title: "Naplaćivanje i Pretplata",
      subtitle: "Upravljajte pretplatom i podacima o naplaćivanju vaše organizacije",
      trialActive: "Aktivno Probno Razdoblje",
      trialDaysRemaining: "{{days}} dana preostalo u vašem probnom razdoblju",
      trialExpired: "Vaše probno razdoblje je isteklo",
      upgradeNow: "Nadogradite Sada",
      currentSubscription: "Trenutna Pretplata",
      plan: "Plan",
      status: "Status",
      nextBillingDate: "Sljedeći Datum Naplaćivanja",
      unknownPlan: "Nepoznat Plan",
      paymentRequired: "Potrebna Uplata",
      paymentOverdue: "Uplata vaše pretplate je dospjela. Molimo ažurirajte način plaćanja.",
      noActiveSubscription: "Nema Aktivne Pretplate",
      noSubscriptionMessage: "Vaša organizacija još nema aktivnu pretplatu.",
      organizationUsage: "Korištenje Organizacije",
      activeMembers: "Aktivni Članovi",
      searchesThisMonth: "Pretraživanja Ovaj Mjesec",
      activeCases: "Aktivni Slučajevi",
      apiCallsThisMonth: "API Pozivi Ovaj Mjesec",
      billingActions: "Akcije Naplaćivanja",
      manageSubscription: "Upravljaj Pretplatom",
      manageSubscriptionDesc: "Ažuriraj način plaćanja, pogledaj račune, promijeni plan",
      notAvailableDuringTrial: "Nije dostupno tijekom probnog razdoblja",
      opening: "Otvaranje...",
      usageAnalytics: "Analitika Korištenja",
      usageAnalyticsDesc: "Detaljni izvještaji o korištenju i analitika (Uskoro)",
      needHelp: "Trebate Pomoć?",
      needHelpMessage: "Ako imate pitanja o naplaćivanju ili trebate napraviti promjene pretplate, naš tim za podršku tu je da vam pomogne.",
      contactSupport: "Kontaktiraj Podršku →"
    }
  },
  profile: {
    title: "Postavke računa",
    subscription: "Pretplata",
    organizationSubscription: "Organizacijska pretplata",
    organization: "Organizacija",
    role: "Uloga",
    admin: "Administrator organizacije",
    member: "Član",
    manageSubscription: "Upravljaj pretplatom",
    subscribeNow: "Pretplati se sada",
    noSubscription: "Nemate aktivnu pretplatu.",
    noOrganizationSubscription: "Vaša organizacija nema aktivnu pretplatu.",
    contactAdmin: "Kontaktirajte administratora organizacije za upravljanje naplatom i pretplatama.",
    status: "Status",
    tier: "Razina",
    active: "Aktivan",
    professional: "Profesionalni",
    starter: "Početni",
    accountCreated: "Račun stvoren",
    lastSignIn: "Zadnja prijava",
    nextBilling: "Sljedeća naplata",
    paymentOverdue: "Dospjela uplata",
    marketingPreferences: "Marketing Preferencije",
    sanctionsUpdates: "Ažuriranja Sankcija i Usklađenosti",
    marketingDescription: "Primajte prioritetne obavijesti o kritičnim ažuriranjima sankcija, regulatornim promjenama i novim funkcijama usklađenosti koje bi mogle utjecati na vaše poslovanje.",
    marketingOn: "Primit ćete marketinške komunikacije",
    marketingOff: "Nećete primati marketinške komunikacije",
    marketingEnabled: "Marketinške obavijesti omogućene",
    marketingDisabled: "Marketinške obavijesti onemogućene"
  },
  billing: {
    adminRequired: "Potreban pristup administratora organizacije"
  },
  payment: {
    success: {
      title: "Hvala vam na pretplati!",
      subtitle: "Dobrodošli u poboljšanu provjeru sankcija",
      planActive: "Vaša pretplata je sada aktivna",
      features: "Vaš plan uključuje:",
      nextRenewal: "Sljedeće obnavljanje",
      stayUpdated: "Ostanite u tijeku s promjenama sankcija",
      marketingText: "Primajte prioritetne obavijesti o kritičnim ažuriranjima sankcija, regulatornim promjenama i novim funkcijama usklađenosti koje bi mogle utjecati na vaše poslovanje.",
      marketingOptIn: "Da, želim biti obaviješten o važnim ažuriranjima sankcija i usklađenosti",
      continue: "Nastavi na nadzornu ploču",
      footerNote: "Možete upravljati svojom pretplatom i preferencijama u bilo kojem trenutku u postavkama računa."
    }
  },
  sidebar: {
    home: "Početna",
    searchHistory: "Povijest pretraživanja",
    admin: "Administracija",
    adminRole: "Administrator",
    userRole: "Korisnik",
    navigation: "Navigacija",
    massUpload: "Masovno učitavanje",
    monitoring: "Praćenje",
    cases: "Slučajevi"
  },
  massUpload: {
    title: "Masovna provjera",
    description: "Učitajte i provjerite više imena odjednom prema listama sankcija",
    selectFile: "Odaberite CSV datoteku ili povucite i ispustite",
    loadingJobs: "Nije moguće učitati poslove...",
    loadingResults: "Nije moguće učitati konsolidirane rezultate...",
    loadingJobDetails: "Nije moguće učitati detalje posla...",
    loadMore: "Učitaj više poslova",
    loadingMore: "Učitavanje više poslova...",
    noJobs: "Nisu pronađeni poslovi provjere",
    startFirstJob: "Započnite svoj prvi posao provjere",
    jobId: "ID posla",
    startScreening: "Započni provjeru",
    resume: "Nastavi provjeru",
    processing: "Obrada...",
    pending: "Na čekanju",
    completed: "Završeno",
    foundMatches: "Pronađena podudaranja",
    error: "Greška",
    progress: "Napredak",
    summaryTitle: "Sažetak rezultata provjere",
    totalProcessed: "Ukupno obrađeno",
    namesWithMatches: "Imena s podudaranjima",
    namesWithoutMatches: "Imena bez podudaranja",
    totalMatchesFound: "Ukupno pronađeno podudaranja",
    clearAndNew: "Očisti i novi",
    emptyStateMessage: "Učitajte datoteku s imenima za početak skupne provjere",
    uploading: "Učitavanje datoteke...",
    namesLoaded: "{{count}} imena učitana",
    name: "Ime",
    status: "Status",
    matches: "Podudaranja",
    verificationId: "ID verifikacije",
    actions: "Akcije",
    viewMatches: "Pregledaj podudaranja",
    hideMatches: "Sakrij podudaranja",
    matchDetails: "Detalji podudaranja",
    sanctionName: "Ime na listi sankcija",
    matchPercentage: "% podudaranja",
    confidenceLevel: "Razina pouzdanosti",
    sources: "Izvori",
    noDetailedMatches: "Nema dostupnih detaljnih informacija o podudaranju",
    noSourceInfo: "Nema informacija o izvoru",
    downloadPdf: "Preuzmi PDF",
    viewFullReport: "Pogledaj cijeli izvještaj",
    jobsTitle: "Poslovi provjere",
    newJob: "Novi posao",
    startTime: "Vrijeme početka",
    namesCount: "Imena",
    matchesFound: "Pronađena podudaranja",
    view: "Pregledaj",
    viewJob: "Pregledaj detalje posla",
    backToJobs: "Natrag na poslove",
    currentJob: "Trenutni posao",
    downloadResults: "Preuzmi rezultate kao CSV",
    downloadSuccess: "Rezultati uspješno preuzeti",
    continued: "Nastavljeno",
    completedWithErrors: "Završeno s greškama",
    parentJobTitle: "Informacije o nadređenom poslu",
    showChildJobs: "Prikaži serije",
    hideChildJobs: "Sakrij serije",
    totalBatches: "Ukupno serija",
    totalNames: "Ukupno imena",
    highConfidenceMatches: "Podudaranja visoke pouzdanosti",
    continuationChain: "Lanac nastavaka",
    continuationExplanation: "Ovaj posao je dio niza povezanih serija provjere. Svi poslovi u lancu prikazani su ispod s njihovim trenutnim statusom.",
    jobsInChain: "poslova u ovom lancu",
    continuationInfo: "Informacije o nastavku",
    chainedJobs: "{{count}} poslova u lancu",
    parentJob: "Nadređeni posao",
    jobType: "Vrsta posla",
    standardJob: "Standardni posao",
    jobPart: "Dio posla",
    cancelJob: "Otkaži posao",
    cancelling: "Otkazivanje...",
    stopping: "Zaustavljanje",
    stopped: "Zaustavljeno",
    jobCancellationRequested: "Zatraženo otkazivanje posla. Posao će se zaustaviti nakon završetka trenutne serije.",
    couldNotCancelJob: "Nije moguće otkazati posao",
    failedToCancelJob: "Neuspjelo otkazivanje posla",
    fileInfo: "Učitajte CSV ili TXT datoteku s jednim imenom po retku",
    batchSizeLimit: "Maksimalno 250 imena po seriji",
    limitReached: "Dosegnuto mjesečno ograničenje pretraživanja",
    batchSizeLimitError: "Prekoračeno ograničenje veličine serije: Vaša datoteka sadrži {{count}} imena, ali maksimalno dozvoljeno je 250. Molimo podijelite podatke u manje serije ili smanjite broj imena u datoteci.",
    errorProcessingFile: "Greška pri obradi datoteke",
    downloadSample: "Preuzmi ogledni CSV",
    oneJobLimit: "Dopuštena je samo jedna aktivna obrada istovremeno",
    activeJobError: "Već imate aktivan posao obrade. Molimo pričekajte da se završi prije pokretanja novog."
  },
  themes: {
    light: "Svijetli Način",
    dark: "Tamni Način"
  },
  language: {
    en: "Engleski",
    hr: "Hrvatski",
    de: "Njemački",
    fr: "Francuski",
    switchTo: "Prebaci na",
    comingSoon: "Uskoro Dostupno"
  },
  errors: {
    general: "Nešto je pošlo po zlu. Molimo pokušajte ponovno.",
    login: "Nevažeći e-mail ili lozinka.",
    required: "Ovo polje je obavezno.",
    invalidEmail: "Molimo unesite valjanu e-mail adresu.",
    passwordMatch: "Lozinke se ne podudaraju.",
    passwordLength: "Lozinka mora imati najmanje 8 znakova.",
    serverError: "Greška poslužitelja. Molimo pokušajte kasnije.",
    notFound: "Stranica nije pronađena",
    unauthorized: "Niste ovlašteni za izvršavanje ove radnje.",
    forbidden: "Pristup zabranjen.",
    offline: "Čini se da ste offline. Molimo provjerite vašu vezu.",
    timeout: "Isteklo je vrijeme zahtjeva. Molimo pokušajte ponovno.",
    conflict: "Ova operacija je izazvala sukob. Molimo pokušajte ponovno.",
    emptyResult: "Nisu pronađeni rezultati. Molimo pokušajte s drugim pojmom za pretraživanje.",
    validation: "Molimo ispravite pogreške u obrascu.",
    jobNotFound: "Traženi posao nije pronađen.",
    jobAccessDenied: "Nemate dopuštenje za pristup ovom poslu.",
    noVerificationId: "Nema dostupnog ID-a verifikacije za ovo podudaranje.",
    unexpectedError: "Došlo je do neočekivane pogreške. Molimo pokušajte ponovno.",
    authRequired: "Potrebna je autentifikacija",
    permissionDenied: "Pristup odbijen",
    invalidInput: "Neispravan unos. Molimo provjerite podatke i pokušajte ponovno.",
    requestFailed: "Zahtjev nije uspio. Molimo provjerite vezu i pokušajte ponovno.",
    timeoutError: "Isteklo je vrijeme zahtjeva. Molimo pokušajte ponovno.",
    authError: "Pogreška pri autentifikaciji. Molimo prijavite se ponovno.",
    apiError: "API pogreška. Molimo pokušajte kasnije.",
    searchError: "Pogreška pri pretraživanju. Molimo pokušajte ponovno.",
    uploadError: "Pogreška pri učitavanju datoteke. Molimo pokušajte ponovno.",
    downloadError: "Pogreška pri preuzimanju datoteke. Molimo pokušajte ponovno.",
    pdfGenerationFailed: "Došlo je do greške pri generiranju PDF izvještaja.",
    downloadFailed: "Preuzimanje rezultata nije uspjelo. Molimo pokušajte ponovno.",
    googleAuthFailed: "Google autentifikacija nije uspjela. Molimo pokušajte ponovno.",
    popupClosed: "Prozor za autentifikaciju je zatvoren. Molimo pokušajte ponovno.",
    accountExists: "Račun s istom e-mail adresom već postoji."
  },
  pdf: {
    pageOf: "Stranica {{current}} od {{total}}",
    sanctionsCheckHeader: "Rezultati Provjere Sankcija",
    verified: "PROVJERENO",
    flagged: "OZNAČENO",
    disclaimer: "ODRICANJE ODGOVORNOSTI: Ovaj izvještaj služi samo u informativne svrhe i ne predstavlja pravni savjet. Informacije sadržane u ovom izvještaju točne su na dan generiranja.",
    confidential: "POVJERLJIVO - SAMO ZA OVLAŠTENU UPOTREBU"
  },
  monitoring: {
    addedSuccess: "Uspješno dodano u praćenje",
    addError: "Greška pri dodavanju u praćenje",
    removedSuccess: "Uspješno uklonjeno iz praćenja",
    removeError: "Greška pri uklanjanju iz praćenja",
    missingVerificationId: "Nedostaje ID verifikacije za praćenje",
    alreadyMonitored: "Ovaj entitet se već prati",
    notMonitored: "Ovaj entitet se ne prati",
    title: "Nadzor entiteta",
    description: "Pratite entitete i automatski ponovno provjeravajte u redovitim intervalima",
    emptyMessage: "Dodajte imena za praćenje sa stranice rezultata pretraživanja",
    noMonitoredSearches: "Nema praćenih entiteta",
    totalMonitored: "Ukupno praćeno",
    verificationId: "ID verifikacije",
    addedOn: "Dodano",
    lastChecked: "Zadnja provjera",
    runSearch: "Pokreni pretraživanje",
    removeFromMonitoring: "Ukloni",
    removedSuccess: "Uklonjeno iz praćenja",
    removeError: "Greška pri uklanjanju iz praćenja",
    fetchError: "Greška pri učitavanju praćenih entiteta",
    searchError: "Došlo je do greške prilikom pretraživanja",
    errorTitle: "Greška pri učitavanju praćenja",
    indexBuildingError: "Indeks pretraživanja se trenutno gradi. Molimo pokušajte ponovno za minutu.",
    searchCadenceLabel: "Učestalost automatske ponovne provjere",
    cadenceDescription: "Odaberite koliko često bismo trebali automatski ponovno provjeriti ova imena prema najnovijim podacima o sankcijama",
    cadence3Months: "Svaka 3 mjeseca",
    cadence6Months: "Svakih 6 mjeseci",
    cadence9Months: "Svakih 9 mjeseci",
    cadence1Year: "Jednom godišnje",
    cadence2Years: "Svake 2 godine",
    cadenceSaved: "Učestalost ponovne provjere spremljena",
    saveCadenceError: "Greška pri spremanju učestalosti ponovne provjere",
    filterMonitored: "Filtrirajte praćene entitete...",
    searching: "Pretraživanje...",
    noMatchingSearches: "Nisu pronađeni praćeni entiteti koji odgovaraju vašem filtru"
  },
  history: {
    searchHistory: "Povijest pretraživanja",
    yourRecentSearches: "Vaša nedavna pretraživanja svih lista sankcija",
    loading: "Nije moguće učitati vašu povijest pretraživanja...",
    loadMore: "Učitaj više",
    backToHistory: "Natrag na povijest",
    searchDetails: "Detalji pretraživanja",
    recordsScanned: "Pregledano zapisa",
    matchesFound: "Pronađena podudaranja",
    verificationId: "ID verifikacije",
    sourcesChecked: "Provjereni izvori",
    rerunSearch: "Pokreni novo pretraživanje",
    runningSearch: "Pretraživanje u tijeku...",
    matchedEntities: "Podudarajući entiteti",
    rerunResults: "Novi rezultati pretraživanja",
    matches: "Podudaranja",
    moreMatches: "više podudaranja",
    noMatches: "Nisu pronađena podudaranja",
    rerunError: "Greška pri pokretanju pretraživanja",
    noSearchesYet: "Još nema pretraživanja",
    searchesToAppearHere: "Vaša pretraživanja će se pojaviti ovdje nakon što pretražite neko ime",
    filterSearches: "Filtrirajte vašu povijest pretraživanja...",
    searching: "Pretraživanje...",
    noMatchingSearches: "Nisu pronađena pretraživanja koja odgovaraju vašem filtru"
  },
  user: {
    profile: "Profil",
    settings: "Postavke",
    account: "Račun",
    history: "Povijest",
    language: "Jezik",
    theme: "Tema",
    notifications: "Obavijesti",
    security: "Sigurnost",
    personalInfo: "Osobni podaci",
    changePassword: "Promijeni lozinku",
    twoFactor: "Dvofaktorska autentifikacija",
    firstName: "Ime",
    lastName: "Prezime",
    company: "Tvrtka",
    position: "Pozicija",
    phoneNumber: "Telefonski broj",
    address: "Adresa",
    update: "Ažuriraj profil",
    oldPassword: "Stara lozinka",
    newPassword: "Nova lozinka",
    confirmPassword: "Potvrdi lozinku",
    passwordChanged: "Lozinka uspješno promijenjena"
  },
  admin: {
    dashboard: "Nadzorna ploča",
    users: "Korisnici",
    searchHistory: "Povijest pretraživanja",
    monitoring: "Praćenje",
    settings: "Postavke",
    systemStatus: "Status sustava",
    viewLogs: "Pregledaj zapise",
    updateDatabase: "Ažuriraj bazu podataka",
    addUser: "Dodaj korisnika",
    editUser: "Uredi korisnika",
    deleteUser: "Izbriši korisnika",
    statistics: "Statistika",
    apiKeys: "API ključevi",
    integrations: "Integracije",
    createApiKey: "Kreiraj API ključ",
    revokeApiKey: "Opozovi API ključ",
    databaseStats: "Statistika baze podataka",
    lastUpdate: "Zadnje ažuriranje",
    totalRecords: "Ukupno zapisa",
    searchesPerDay: "Pretraživanja po danu",
    activeUsers: "Aktivni korisnici",
    totalMonitored: "Ukupno praćenih entiteta",
    alerts: "Upozorenja",
    daily: "Dnevno",
    weekly: "Tjedno",
    monthly: "Mjesečno"
  },
  cases: {
    title: "Upravljanje slučajevima",
    loading: "Učitavanje slučajeva...",
    errorFetching: "Nije moguće učitati slučajeve",
    noCases: "Nije pronađen nijedan slučaj",
    totalCases: "Ukupno slučajeva",
    openCases: "Otvoreni slučajevi",
    allOpenCases: "Svi otvoreni",
    inProgressCases: "U tijeku",
    completedCases: "Završeni",
    matches: "Podudaranja",
    reviewed: "Pregledano",
    minute: "minuta",
    minutes: "minute",
    hour: "sat",
    hours: "sati",
    day: "dan",
    days: "dana",
    ago: "prije",
    statusPending: "Na čekanju",
    statusInProgress: "U tijeku",
    statusCompleted: "Završeno",
    refresh: "Osvježi",
    filters: {
      all: "Svi",
      allOpen: "Svi otvoreni",
      pending: "Na čekanju",
      inProgress: "U tijeku",
      completed: "Završeni"
    },
    report: {
      downloadButton: "Preuzmi izvještaj",
      tooltip: "Izvještaj slučaja može se preuzeti tek nakon što su pregledana sva potencijalna podudaranja.",
      loading: "Generiranje izvještaja...",
      error: "Greška pri generiranju izvještaja",
      caseCompleted: "Slučaj završen",
      casePending: "Slučaj mora biti potpuno pregledan za preuzimanje izvještaja",
      matchesConfirmed: "Potvrđena podudaranja sa sankcijama",
      noMatchesConfirmed: "Nema podudaranja sa sankcijama",
      reviewedBy: "Pregledao/la",
      caseSummary: "Sažetak slučaja",
      confirmedMatches: "potvrđena podudaranja",
      allMatchesCleared: "Sva podudaranja očišćena",
      statusUnknown: "Nepoznat status"
    }
  },
  cookies: {
    consent: "Ova web stranica koristi kolačiće za poboljšanje korisničkog iskustva.",
    accept: "Prihvati",
    deny: "Odbij",
    privacyPolicy: "Politika privatnosti"
  },
  pastdue: {
    banner: "Vaša uplata kasni {{days}} dana. Molimo ažurirajte svoje podatke o plaćanju.",
    resolve: "Ažurirajte Način Plaćanja",
    modal: {
      title: "Dospjela Uplata",
      message: "Vaša pretplata je dospjela za plaćanje. Ne možete koristiti aplikaciju dok ne riješite plaćanje.",
      button: "Ažurirajte Način Plaćanja"
    }
  },
  trial: {
    banner: "Vaša besplatna probna verzija istječe za {{days}} dana. Nadogradite za nastavak korištenja svih funkcija.",
    daysRemaining: "{{days}} dana preostalo",
    status: "PROBNO",
    upgrade: "Nadogradi odmah",
    activeTitle: "Aktivna Besplatna Probna Verzija",
    description: "Trenutno uživate puni pristup svim profesionalnim funkcijama tijekom vašeg besplatnog probnog razdoblja.",
    upgradePrompt: "Pređite na plaćeni plan prije kraja probne verzije da biste nastavili koristiti sve funkcije."
  },
  pricing: {
    choose_plan: "Odaberite Vaš Plan",
    upgrade_plan: "Nadogradite Plan",
    restart_subscription: "Ponovno Pokrenite Pretplatu",
    subtitle: "Otključajte punu snagu provjere sankcija",
    monthly: "Mjesečno",
    yearly: "Godišnje",
    billed_annually: "naplaćuje se godišnje",
    save: "Uštedite",
    most_popular: "Najpopularniji",
    recommended: "Preporučeno",
    
    starter: "Početni",
    professional: "Profesionalni",
    enterprise: "Enterprise",
    custom: "Prilagođeno",
    
    searches_100: "100 pretraga mjesečno",
    searches_500: "500 pretraga mjesečno",
      searches_1000: "Do 100 pretraga mjesečno",
  searches_10000: "Do 1.000 pretraga mjesečno",
    unlimited_searches: "Neograničene pretrage",
    
    basic_support: "Osnovna korisničku podršku",
    priority_support: "Prioritetna korisnička podrška",
    dedicated_support: "Posvećeni upravitelj računa",
    
    email_notifications: "E-mail obavijesti",
    advanced_notifications: "Napredne obavijesti",
    
    basic_dashboard: "Osnovna nadzorna ploča",
    detailed_reports: "Detaljni izvještaji",
    
    api_access: "API pristup",
    rest_api_access: "REST API pristup",
    bulk_screening: "Masovno screening",
    batch_screening: "Skupno screening",
    team_members_3: "3 člana tima",
    team_members_10: "10 članova tima",
    active_monitoring: "Aktivno praćenje",
    case_management: "Upravljanje slučajevima",
    custom_integrations: "Prilagođene integracije",
    white_label: "White-label rješenje",
    sla: "SLA garancija",
    on_premise: "On-premise opcija implementacije",
    
    get_started: "Počnite",
    upgrade_now: "Nadogradite Sada",
    contact_sales: "Kontaktirajte Prodaju"
  }
};

export default hr;